<template>
    <path fill-rule="evenodd" d="M16 0C7.163 0 0 7.163 0 16s7.163 16 16 16c8.836 0 16-7.164 16-16 0-8.837-7.164-16-16-16zm0 30C8.268 30 2 23.732 2 16S8.268 2 16 2s14 6.268 14 14-6.268 14-14 14zm7.3-19.607L13.012 20.589l-4.281-4.196c-.394-.391-1.034-.391-1.428 0-.394.391-.395 1.024 0 1.414l4.999 4.899c.41.361 1.023.401 1.428 0l10.999-10.899c.394-.39.394-1.024 0-1.414-.394-.39-1.034-.39-1.429 0z"/>
</template>

<script>
export default {
    name: 'notificationSuccessIcon',
    beforeMount() {
        this.$parent.$emit('size', '0 0 32 32');
    }
};
</script>
